import $ from 'jquery';
import _ from 'lodash';

function LoverTab(selector) {
  this.elems = {};
  this.elems.root = $(selector);
  this.elems.selector = this.elems.root.find('[data-lover-selector]');
	this.elems.tabs = [];
	this.elems.currentTab = null;

  this.initTabs();
}

LoverTab.prototype.initTabs = function initTabs() {
  this.elems.tabs = [];
  let self = this;

  // console.log(this.elems.root.html());

  // Atualiza a imagem da tab
  // const updateTabsImgs = () => {
  //   $(self.elems.tabs).each(function() {
  //     let tab = $(this);
  //     let imgElem = tab.find('[data-lover-img]');
  //     let isTabActive = tab.hasClass('active');

  //     let background = isTabActive
  //         ? imgElem.attr('data-lover-img-active')
  //         : imgElem.attr('data-lover-img');

  //     console.log('ok ', background);

  //     imgElem.css({
  //       'backgroundImage': 'url("' + background + '")'
  //     });
  //   });
  // };

  // Bind click events
  let leTabs = this.elems.root.find('[data-lover-tab]');
  let win = $(window);

  const setTab = function(tab) {
		// Update active class
		if(!self.elems.currentTab || self.elems.currentTab[0] != tab[0]) {
			$(leTabs).removeClass('active');
			tab.addClass('active');
			self.elems.currentTab = tab;

			// Show visible content
			let targetName = tab.attr('data-lover-tab');
			$('[data-lover-target]').hide();
			$('[data-lover-target="' + targetName + '"]').fadeIn('slow');
		}
		// Move selector
		let winWidth = win.width();
		let isMobile = winWidth <= 500;
    setTimeout(function() {
      self.elems.selector.show();
      let tabPos = tab.position();
      let offsetLeft = parseInt(tab.css('margin-left').replace('px', '')) + 4;
      let offsetTop = parseInt(tab.css('margin-top').replace('px',''));
      let newLeft = tabPos.left + offsetLeft; // + tabCenter.w, // - selWidth / 2,
      let newTop = tabPos.top + offsetTop; // + tabCenter.h - selHeight / 2,
      self.elems.selector.css({
        left: newLeft,
        top: newTop,
      });
      self.elems.root.animate({
        scrollLeft: newLeft - winWidth / 2 + self.elems.selector.width() / 2,
      });
    }, isMobile ? 310 : 0); // delay to mobile (wait css scale)
  };

  leTabs.each(function() {
    let tab = $(this);
    self.elems.tabs.push(tab);

    tab.click(() => {
      setTab(tab);
    });
	});
	
	let resizeTabs = function() {
		// set horizontal wrapper width (for mobile)
		let elRT = self.elems.root.find('.estampa-tabs');
		if(win.width() <= 500) {
			let tabWidth = 130;
			elRT.width(((self.elems.tabs.length - 1) * tabWidth * 0.9) + tabWidth);
		} else {
			elRT.width('auto');
		}
		if(self.elems.currentTab) {
			setTab(self.elems.currentTab);
		}
	};

	win.on('resize', _.debounce(resizeTabs, 200));
	resizeTabs();

  setTab($(leTabs[0]));
};

export default {
  start() {
    $('[data-lover-tabs]').each(function() {
      new LoverTab(this);
    });
  },
};
